import { ViewConfig } from "@lib/views";
import { ViewDensity } from "@common/types/views/views";
import { AccrualLedgerSettingsColumn } from "@common/types/views/accrualLedgerSettingsView";
import { AccrualLedgerSettingsRow } from "./accrualLedgerSettingsUtils";
import { EntityCell } from "./AccrualLedgerCells/EntityCell";
import { ActionCell } from "./AccrualLedgerCells/ActionCell";

export const createAccrualLedgerSettingsViewConfig = (): ViewConfig<
    AccrualLedgerSettingsRow,
    AccrualLedgerSettingsColumn,
    never
> => ({
    columns: {
        [AccrualLedgerSettingsColumn.ENTITY]: {
            accessorKey: "entity.name",
            name: "Entity",
            header: "Entity",
            immutable: true,
            cell: EntityCell,
            minSize: 200,
            maxSize: 600,
        },
        [AccrualLedgerSettingsColumn.ACTION]: {
            accessorKey: "entity.id",
            name: "Action",
            header: "",
            align: "right",
            immutable: true,
            hiddenFromSettings: true,
            cell: ActionCell,
            minSize: 200,
            maxSize: 240,
        },
    },
    density: ViewDensity.LG,
});
